/** Home generate prompt and matching tRPC/projects.create validation. */
export const PROMPT_MAX_CHARS = 10000;
